import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiMessageSquare, FiMapPin, FiGlobe } = FiIcons;

function ContactUs() {
  const contactInfo = [
    {
      icon: FiMail,
      label: "Email Us",
      value: "hi@quoteposter.app",
      link: "mailto:hi@quoteposter.app"
    },
    {
      icon: FiGlobe,
      label: "Website",
      value: "www.quoteposter.app",
      link: "https://quoteposter.app"
    },
    {
      icon: FiMessageSquare,
      label: "Support",
      value: "support@quoteposter.app",
      link: "mailto:support@quoteposter.app"
    }
  ];

  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-[32px] shadow-xl shadow-slate-200/50 overflow-hidden border border-slate-100"
        >
          <div className="grid md:grid-cols-2">
            <div className="p-8 md:p-12 bg-indigo-600 text-white">
              <h1 className="text-3xl font-bold mb-6">Get in Touch</h1>
              <p className="text-indigo-100 mb-12 text-lg">
                Have questions, feedback, or need help with a premium download? We're here for you.
              </p>
              
              <div className="space-y-8">
                {contactInfo.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-indigo-500/50 rounded-xl flex items-center justify-center shrink-0">
                      <SafeIcon icon={item.icon} className="w-5 h-5" />
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-widest text-indigo-200 mb-1">{item.label}</p>
                      <a href={item.link} target="_blank" rel="noopener noreferrer" className="text-lg font-medium hover:text-white transition-colors">
                        {item.value}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="p-8 md:p-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">Send a Message</h2>
              <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                <div className="space-y-2">
                  <label className="text-sm font-bold text-slate-700">Name</label>
                  <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="John Doe" />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-bold text-slate-700">Email</label>
                  <input type="email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-indigo-500 outline-none transition-all" placeholder="john@example.com" />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-bold text-slate-700">Message</label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-indigo-500 outline-none transition-all resize-none" placeholder="How can we help?" />
                </div>
                <button className="w-full py-4 bg-indigo-600 text-white rounded-xl font-bold shadow-lg shadow-indigo-100 hover:bg-indigo-700 transition-all">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default ContactUs;